export const FEATURED_ARTICLES = [
  {
    url: "https://www.wantedly.com/companies/nulab/post_articles/935600",
    title: "【10問10答】SRE 山崎 / ユーザーに近い環境が自身を成長させている。\"リアルな声\"が新たな挑戦の原動力に",
    description: "Wantedlyに掲載されたインタビュー記事。SREとしての経験や考え方について語っています。"
  },
  {
    url: "https://note.com/revsystem/n/n96b117387ad2",
    title: "Product SREs for Backlogの日常的なタスクの取り組みを紹介- プロダクトバックログの改善や生成AIなど幅広くチャレンジ -",
    description: "Product SREs for Backlogの日常的なタスクの取り組みを紹介した記事です。"
  },
  {
    url: "https://nulab.com/ja/blog/nulab/why-be-a-nulaber-interview-yamasaki/",
    title: "Why be a Nulaber? - 山崎毅インタビュー",
    description: "Nulabのエンジニアとして働くことの魅力や、技術的なチャレンジについてのインタビュー記事です。"
  }
];

export const OTHER_LINKS = [
  {
    id: 'career',
    icon: 'Cloud',
    links: [
      {
        title: 'LAPRAS',
        url: 'https://lapras.com/public/revsystem'
      },
      {
        title: 'Wantedly',
        url: 'https://www.wantedly.com/id/TsuyoshiYamasaki'
      }
    ]
  },
  {
    id: 'blog',
    icon: 'BookOpenCheck',
    title: 'Nulab blog',
    url: 'https://nulab.com/ja/blog/nulab/amazon-bedrock-metadata-filtering/',
    description: '"Amazon BedrockのメタデータフィルタでIN句を使って特定の文書を検索する"'
  },
  {
    id: 'presentation',
    icon: 'MonitorPlayIcon',
    title: 'JAWS-UG東京登壇',
    url: 'https://jawsug.connpass.com/event/345497/',
    description: '"Bedrock Converse APIでTool useのJSONモードを使って"クエリ拡張"と"クエリ分解"を試してみた"',
    videoUrl: 'https://www.youtube.com/watch?v=QWMSSDrYplA'
  }
];